import Vue from 'vue';
import DropdownMenu from '@innologica/vue-dropdown-menu'

Vue.component('dropdown-menu', DropdownMenu);
